// Generated from the WildLark app module registry. Run npm run generate:nest-api.

export interface AppOperationMap {
    "computer.capabilities": { params: Record<string, never>; result: { [key: string]: unknown } }
    "computer.live_turns": { params: Record<string, never>; result: { [key: string]: unknown } }
    "computer.status": { params: Record<string, never>; result: { [key: string]: unknown } }
    "conversation.search": { params: { query: string; workspaceId?: string; limit?: number }; result: { [key: string]: unknown } }
    "file.describe": { params: { workspaceId: string; path: string; cwd?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "file.mkdir": { params: { workspaceId: string; path: string; cwd?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "file.read": {
        params: { workspaceId: string; path: string; cwd?: string; worktreeId?: string; offset?: number; maxBytes?: number }
        result: { [key: string]: unknown }
    }
    "file.remove": { params: { workspaceId: string; path: string; cwd?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "file.search": {
        params: { workspaceId: string; path?: string; cwd?: string; worktreeId?: string; query: string; limit?: number }
        result: { [key: string]: unknown }
    }
    "file.write": {
        params: { workspaceId: string; path: string; cwd?: string; worktreeId?: string; content: string; createDirs?: boolean; overwrite?: boolean }
        result: { [key: string]: unknown }
    }
    "followup.cancel": { params: { taskId: string; workspaceId: string; sessionId: string; scheduleId: string }; result: { [key: string]: unknown } }
    "followup.create": {
        params: { taskId: string; workspaceId: string; sessionId: string; at: string; instructions: string; note?: string }
        result: { [key: string]: unknown }
    }
    "followup.list": {
        params: {
            workspaceId?: string
            sessionId?: string
            cursor?: string
            summaryCursor?: string
            schedulesDone?: boolean
            summariesDone?: boolean
            limit?: number
        }
        result: { [key: string]: unknown }
    }
    "followup.run_now": { params: { taskId: string; workspaceId: string; sessionId: string; scheduleId: string }; result: { [key: string]: unknown } }
    "followup.update": {
        params: {
            taskId: string
            workspaceId: string
            sessionId: string
            scheduleId: string
            at?: null | string
            instructions?: null | string
            note?: null | string
            expectedVersion?: null | number
        }
        result: { [key: string]: unknown }
    }
    "git.branches": { params: { workspaceId: string; path?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "git.status": { params: { workspaceId: string; path?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "git.worktrees": { params: { workspaceId: string; path?: string; worktreeId?: string }; result: { [key: string]: unknown } }
    "pr.automation.set": {
        params: { taskId: string; workspaceId: string; sessionId: string }
        result: {
            taskId: string
            status: string
            requested: number
            succeeded: number
            failed: number
            firstErrors: null | Array<string>
            link: {
                id: string
                provider: string
                kind: string
                host: string
                owner: string
                repository: string
                number: number
                url: string
                providerNodeId?: string
                watch: string
                linkedAt: string
            }
            snapshot: {
                number: number
                url: string
                title: string
                state: string
                draft: boolean
                reviewDecision: string
                checks: string
                mergeStateStatus: string
                headSha: string
                updatedAt?: string
                feedbackObserved?: boolean
                feedbackAt?: string
                checkedAt: string
                autoMergeEnabled?: boolean
                mergeQueue?: boolean
            }
            automation?: null | {
                v: number
                linkId: string
                since: string
                phase: string
                delivery?: null | { id: string; kind: string; operation: string }
                hold?: null | { reason: string; source: string; detail?: string; since: string }
                updatedAt: string
            }
        }
    }
    "pr.automation.stop": {
        params: { taskId: string; workspaceId: string; sessionId: string }
        result: { taskId: string; status: string; stopped: boolean; requested: number; succeeded: number; failed: number; firstErrors: null | Array<string> }
    }
    "pr.link": {
        params: { taskId: string; workspaceId: string; sessionId: string; url: string }
        result: {
            taskId: string
            status: string
            link: {
                id: string
                provider: string
                kind: string
                host: string
                owner: string
                repository: string
                number: number
                url: string
                providerNodeId?: string
                watch: string
                linkedAt: string
            }
            requested: number
            succeeded: number
            failed: number
            firstErrors: null | Array<string>
        }
    }
    "pr.read": {
        params: { taskId: string; workspaceId: string }
        result: {
            taskId: string
            link: {
                id: string
                provider: string
                kind: string
                host: string
                owner: string
                repository: string
                number: number
                url: string
                providerNodeId?: string
                watch: string
                linkedAt: string
            }
            snapshot: {
                number: number
                url: string
                title: string
                state: string
                draft: boolean
                reviewDecision: string
                checks: string
                mergeStateStatus: string
                headSha: string
                updatedAt?: string
                feedbackObserved?: boolean
                feedbackAt?: string
                checkedAt: string
                autoMergeEnabled?: boolean
                mergeQueue?: boolean
            }
            automation?: null | {
                v: number
                linkId: string
                since: string
                phase: string
                delivery?: null | { id: string; kind: string; operation: string }
                hold?: null | { reason: string; source: string; detail?: string; since: string }
                updatedAt: string
            }
        }
    }
    "pr.unlink": {
        params: { taskId: string; workspaceId: string; sessionId: string; url: string }
        result: {
            taskId: string
            status: string
            link: {
                id: string
                provider: string
                kind: string
                host: string
                owner: string
                repository: string
                number: number
                url: string
                providerNodeId?: string
                watch: string
                linkedAt: string
            }
            requested: number
            succeeded: number
            failed: number
            firstErrors: null | Array<string>
        }
    }
    "process.batch.start": {
        params: {
            cwd: string
            namespace: string
            labels?: { [key: string]: string }
            processes: null | Array<{
                name: string
                port?: null | number
                command?: string
                args?: null | Array<string>
                script?: string
                shell?: string
                cwd?: string
                env?: { [key: string]: string }
                timeoutMs?: number
            }>
        }
        result: { [key: string]: unknown }
    }
    "process.list": {
        params: { workspaceId?: string; namespace?: string; status?: string; cursor?: string; limit?: number }
        result: { [key: string]: unknown }
    }
    "process.output": { params: { runtimeId: string; offset?: number; maxBytes?: number }; result: { [key: string]: unknown } }
    "process.read": { params: { processId: string }; result: { [key: string]: unknown } }
    "process.restart": { params: { processId: string }; result: { [key: string]: unknown } }
    "process.start": {
        params: {
            name?: string
            port?: null | number
            namespace?: string
            labels?: { [key: string]: string }
            workspaceId?: string
            cwd?: string
            worktreeId?: string
            command?: string
            args?: null | Array<string>
            script?: string
            env?: { [key: string]: string }
            timeoutMs?: number
            label?: string
            clientRequestId?: string
            kind?: string
            shell?: string
            cols?: number
            rows?: number
        }
        result: { [key: string]: unknown }
    }
    "process.stop": { params: { processId: string; signal?: string }; result: { [key: string]: unknown } }
    "project.create": {
        params: { kind: string; name: string; path?: string; url?: string; clientRequestId: string }
        result: { project: { [key: string]: unknown }; warnings: null | Array<string> }
    }
    "project.list": {
        params: { workspaceId?: string; cursor?: string; limit?: number; query?: string }
        result: { items: null | Array<{ [key: string]: unknown }>; nextCursor?: string; hasMore: boolean }
    }
    "project.read": { params: { workspaceId: string }; result: { project: { [key: string]: unknown }; warnings: null | Array<string> } }
    "project.remove": { params: { workspaceId: string }; result: { [key: string]: unknown } }
    "project.update": {
        params: { workspaceId: string; name?: null | string; path?: null | string; archived?: null | boolean }
        result: { project: { [key: string]: unknown }; warnings: null | Array<string> }
    }
    "provider.list": { params: Record<string, never>; result: { [key: string]: unknown } }
    "provider.usage": { params: { providerId: string }; result: { [key: string]: unknown } }
    "session.list": {
        params: { taskId: string; workspaceId: string }
        result: {
            taskId: string
            title?: string
            workspaceId: string
            workspaceRoot: string
            additionalRoots: null | Array<string>
            designatedWorktree?: string
            selectedWorkingDirectory?: string
            repository?: null | { root: string; branch?: string; worktrees: null | Array<{ worktreeId: string; path: string; branch?: string; head?: string }> }
            sessions: null | Array<{
                thinking?: string
                predecessorSessionId?: string
                role?: string
                label?: string
                parentSessionId?: string
                sessionId?: string
                providerId?: string
                providerSessionId?: string
                workspaceId?: string
                sessionFile?: string
                sessionRoot?: string
                cwd?: string
                worktreeId?: string
                executionDirectory?: string
                mode?: string
                model?: string
                status?: string
                activeTurnId?: string
                queuedTurnIds: null | Array<string>
                eventCount: number
                lastInputPreview?: string
                lastEventPreview?: string
                lastTurnId?: string
                createdAt?: string
                updatedAt?: string
                current: boolean
                error?: string
            }>
            sessionReads: { status: string; requested: number; succeeded: number; failed: number; truncated: boolean; firstErrors: null | Array<string> }
        }
    }
    "session.read_messages": {
        params: { taskId: string; workspaceId: string; sessionId: string; messages?: number }
        result: {
            sessionId: string
            sessionFile?: string
            requestedMessages: number
            returnedMessages: number
            hasMore: boolean
            messages: null | Array<{ role: string; text: string; truncated?: boolean }>
        }
    }
    "session.send": {
        params: { taskId: string; workspaceId: string; sessionId: string; prompt: string; clientRequestId: string; disposition?: string }
        result: {
            session: {
                thinking?: string
                predecessorSessionId?: string
                role?: string
                label?: string
                parentSessionId?: string
                sessionId?: string
                providerId?: string
                providerSessionId?: string
                workspaceId?: string
                sessionFile?: string
                sessionRoot?: string
                cwd?: string
                worktreeId?: string
                executionDirectory?: string
                mode?: string
                model?: string
                status?: string
                activeTurnId?: string
                queuedTurnIds: null | Array<string>
                eventCount: number
                lastInputPreview?: string
                lastEventPreview?: string
                lastTurnId?: string
                createdAt?: string
                updatedAt?: string
                current: boolean
                error?: string
            }
            turn: {
                turnId: string
                sessionId: string
                status: string
                clientRequestId?: string
                queuedAt?: string
                startedAt?: string
                completedAt?: string
                error?: string
            }
            queued: boolean
            effectiveDisposition: string
            reused: boolean
            warnings: null | Array<string>
        }
    }
    "session.set_directory": {
        params: { taskId: string; workspaceId: string; sessionId: string; path: string }
        result: { taskId: string; workingDir: string; sessionId: string; displayOnly: boolean }
    }
    "session.start": {
        params: {
            thinking?: string
            taskId: string
            workspaceId: string
            sessionId: string
            harnessId: string
            model?: string
            label?: string
            prompt: string
            clientRequestId: string
            mode?: string
        }
        result: {
            session: {
                thinking?: string
                predecessorSessionId?: string
                role?: string
                label?: string
                parentSessionId?: string
                sessionId?: string
                providerId?: string
                providerSessionId?: string
                workspaceId?: string
                sessionFile?: string
                sessionRoot?: string
                cwd?: string
                worktreeId?: string
                executionDirectory?: string
                mode?: string
                model?: string
                status?: string
                activeTurnId?: string
                queuedTurnIds: null | Array<string>
                eventCount: number
                lastInputPreview?: string
                lastEventPreview?: string
                lastTurnId?: string
                createdAt?: string
                updatedAt?: string
                current: boolean
                error?: string
            }
            turn: {
                turnId: string
                sessionId: string
                status: string
                clientRequestId?: string
                queuedAt?: string
                startedAt?: string
                completedAt?: string
                error?: string
            }
            queued: boolean
            effectiveDisposition: string
            reused: boolean
            warnings: null | Array<string>
        }
    }
    "session.status": {
        params: { taskId: string; workspaceId: string; sessionId: string }
        result: {
            session: {
                thinking?: string
                predecessorSessionId?: string
                role?: string
                label?: string
                parentSessionId?: string
                sessionId?: string
                providerId?: string
                providerSessionId?: string
                workspaceId?: string
                sessionFile?: string
                sessionRoot?: string
                cwd?: string
                worktreeId?: string
                executionDirectory?: string
                mode?: string
                model?: string
                status?: string
                activeTurnId?: string
                queuedTurnIds: null | Array<string>
                eventCount: number
                lastInputPreview?: string
                lastEventPreview?: string
                lastTurnId?: string
                createdAt?: string
                updatedAt?: string
                current: boolean
                error?: string
            }
            turn?: null | {
                turnId: string
                sessionId: string
                status: string
                clientRequestId?: string
                queuedAt?: string
                startedAt?: string
                completedAt?: string
                error?: string
            }
        }
    }
    "session.stop": {
        params: { taskId: string; workspaceId: string; sessionId: string }
        result: { sessionId: string; status: string; requested: number; succeeded: number; failed: number; firstErrors: null | Array<string> }
    }
    "settings.read": { params: Record<string, never>; result: { [key: string]: unknown } }
    "settings.update": {
        params: {
            theme?: null | string
            globalSystemPrompt?: null | string
            permissionMode?: null | string
            pinnedTaskIds?: null | Array<string>
            renderMarkdownMessages?: null | boolean
        }
        result: { [key: string]: unknown }
    }
    "task.close": { params: { taskId: string; workspaceId: string }; result: { taskId: string; closed: boolean; alreadyClosed: boolean } }
    "task.create": {
        params: {
            thinking?: string
            workspaceId: string
            description: string
            harnessId: string
            model?: string
            clientRequestId: string
            agentGitContext?: null | { v: number; baseDir: string; worktreePath: string; startHead?: string; deviceId: string; createdAt: string }
            enabledMcpServerIds?: null | Array<string>
        }
        result: {
            task: { [key: string]: unknown }
            session: {
                thinking?: string
                predecessorSessionId?: string
                role?: string
                label?: string
                parentSessionId?: string
                sessionId?: string
                providerId?: string
                providerSessionId?: string
                workspaceId?: string
                sessionFile?: string
                sessionRoot?: string
                cwd?: string
                worktreeId?: string
                executionDirectory?: string
                mode?: string
                model?: string
                status?: string
                activeTurnId?: string
                queuedTurnIds: null | Array<string>
                eventCount: number
                lastInputPreview?: string
                lastEventPreview?: string
                lastTurnId?: string
                createdAt?: string
                updatedAt?: string
                current: boolean
                error?: string
            }
            reused: boolean
        }
    }
    "task.delete": {
        params: { taskId: string; workspaceId: string }
        result: { taskId: string; deleted: boolean; requested: number; succeeded: number; failed: number; errors: null | Array<string> }
    }
    "task.list": {
        params: { workspaceId?: string; cursor?: string; limit?: number; query?: string }
        result: { items: null | Array<{ [key: string]: unknown }>; nextCursor?: string; hasMore: boolean }
    }
    "task.read": { params: { taskId: string; workspaceId: string }; result: { [key: string]: unknown } }
    "task.reopen": { params: { taskId: string; workspaceId: string }; result: { [key: string]: boolean } }
    "task.sleep": {
        params: { taskId: string; workspaceId: string; until: string }
        result: { taskId: string; attention: { at: string; sleepUntil?: string; source: string; reason?: string } }
    }
    "task.update": {
        params: { taskId: string; workspaceId: string; title?: null | string; description?: null | string; priority?: null | boolean }
        result: { [key: string]: unknown }
    }
    "task.wake": {
        params: { taskId: string; workspaceId: string }
        result: { taskId: string; attention: { at: string; sleepUntil?: string; source: string; reason?: string } }
    }
    "terminal.list": { params: { workspaceId: string }; result: { [key: string]: unknown } }
    "terminal.read": { params: { runtimeId: string; offset?: number; maxBytes?: number }; result: { [key: string]: unknown } }
    "terminal.start": {
        params: {
            workspaceId: string
            cwd?: string
            worktreeId?: string
            command: string
            args?: null | Array<string>
            label?: string
            clientRequestId: string
            timeoutMs?: number
        }
        result: { [key: string]: unknown }
    }
    "terminal.stop": { params: { terminalId: string }; result: { [key: string]: unknown } }
    "terminal.write": { params: { terminalId: string; data: string }; result: { [key: string]: unknown } }
}
export type AppOperationName = keyof AppOperationMap
export const APP_CLIENT_TOOLS = {
    actions: { list: "wildlark_actions_list", run: "wildlark_actions_run" },
    interface: { context: "wildlark_ui_context", control: "wildlark_ui_control" },
    computers: { call: "wildlark_computer_call", describe: "wildlark_computer_describe", list: "wildlark_computer_list" },
} as const
export const APP_OPERATIONS = [
    {
        name: "computer.capabilities",
        module: "runtime",
        effect: "read",
        description: "Describe the local runtime's supported operations and provider capabilities.",
    },
    {
        name: "computer.live_turns",
        module: "runtime",
        effect: "read",
        description: "List authoritative active and queued turns on this computer without reading history.",
    },
    { name: "computer.status", module: "runtime", effect: "read", description: "Read current local runtime counters and host resource measurements." },
    {
        name: "conversation.search",
        module: "runtime",
        effect: "read",
        description: "Search indexed human and assistant text. Results include index coverage; task metadata remains separately readable.",
    },
    { name: "file.describe", module: "runtime", effect: "read", description: "Describe a file or directory on the selected computer." },
    { name: "file.mkdir", module: "runtime", effect: "write", description: "Create a directory within a project." },
    { name: "file.read", module: "runtime", effect: "read", description: "Read a bounded portion of a text file; follow nextOffset when needed." },
    { name: "file.remove", module: "runtime", effect: "write", description: "Remove an explicitly selected file or empty directory." },
    { name: "file.search", module: "runtime", effect: "read", description: "Find matching text within project files." },
    { name: "file.write", module: "runtime", effect: "write", description: "Write a project file, with explicit overwrite and directory creation options." },
    { name: "followup.cancel", module: "sessions", effect: "agent", description: "Cancel a follow-up that has not started." },
    { name: "followup.create", module: "sessions", effect: "agent", description: "Schedule a future turn in a task thread at an RFC3339 timestamp." },
    {
        name: "followup.list",
        module: "sessions",
        effect: "read",
        description: "List a page of follow-ups and delivery summaries; continue both returned cursors until each is done.",
    },
    { name: "followup.run_now", module: "sessions", effect: "agent", description: "Run an existing follow-up using its saved execution profile." },
    {
        name: "followup.update",
        module: "sessions",
        effect: "agent",
        description: "Reschedule or edit a pending follow-up, optionally checking its saved version.",
    },
    { name: "git.branches", module: "runtime", effect: "read", description: "List checkout branches and the authoritative default branch when available." },
    { name: "git.status", module: "runtime", effect: "read", description: "Read staged, unstaged, and untracked changes for a checkout." },
    { name: "git.worktrees", module: "runtime", effect: "read", description: "List existing Git worktrees for a project." },
    {
        name: "pr.automation.set",
        module: "sessions",
        effect: "agent",
        description:
            "Watch PR in the background: repair clear blockers and surface readiness or human attention. Does not sleep the task; use task.sleep with until=pr_ready to explicitly wait. Never merge or close automatically.",
    },
    {
        name: "pr.automation.stop",
        module: "sessions",
        effect: "agent",
        description: "Turn off a task's pull request automation and cancel queued PR work while keeping the link.",
    },
    {
        name: "pr.link",
        module: "sessions",
        effect: "agent",
        description: "Link a pull or merge request. A new GitHub link starts Watch PR in the background without sleeping the task.",
    },
    { name: "pr.read", module: "sessions", effect: "read", description: "Read the current state of a task's linked pull request." },
    { name: "pr.unlink", module: "sessions", effect: "agent", description: "Remove a task's linked pull request and stop its automation." },
    { name: "process.batch.start", module: "runtime", effect: "exec", description: "Launch a set of named global processes in a directory." },
    { name: "process.list", module: "runtime", effect: "read", description: "List managed processes across the computer; follow nextCursor." },
    { name: "process.output", module: "runtime", effect: "read", description: "Read bounded managed-process output from a chunk offset." },
    { name: "process.read", module: "runtime", effect: "read", description: "Read a managed process." },
    { name: "process.restart", module: "runtime", effect: "exec", description: "Restart a managed process using its saved recipe." },
    { name: "process.start", module: "runtime", effect: "exec", description: "Start an observable managed command on the selected computer." },
    { name: "process.stop", module: "runtime", effect: "exec", description: "Stop a managed process." },
    {
        name: "project.create",
        module: "projects",
        effect: "write",
        description:
            "Register an existing directory, create a Git project, clone a repository, or create a lightweight prototype. Retry with the same request id.",
    },
    { name: "project.list", module: "projects", effect: "read", description: "List a page of projects, including archived projects." },
    { name: "project.read", module: "projects", effect: "read", description: "Read one project by its workspace id." },
    {
        name: "project.remove",
        module: "projects",
        effect: "write",
        description: "Remove an empty project registration. Files remain on disk; a project with sessions cannot be removed.",
    },
    { name: "project.update", module: "projects", effect: "write", description: "Rename, relocate, archive, or restore a project." },
    { name: "provider.list", module: "runtime", effect: "read", description: "List installed providers, availability, and effective model catalogs." },
    { name: "provider.usage", module: "runtime", effect: "read", description: "Read provider account usage and quota availability." },
    { name: "session.list", module: "sessions", effect: "read", description: "List the threads and working directories belonging to a task." },
    { name: "session.read_messages", module: "sessions", effect: "read", description: "Read bounded recent human and assistant messages from a task thread." },
    {
        name: "session.send",
        module: "sessions",
        effect: "agent",
        description: "Start or continue a task thread; enqueue, steer, or interrupt according to disposition. Retry with the same clientRequestId.",
    },
    { name: "session.set_directory", module: "sessions", effect: "agent", description: "Set the working directory for future turns in a task thread." },
    {
        name: "session.start",
        module: "sessions",
        effect: "agent",
        description: "Start a visible child thread in a task. App-control grants are not inherited.",
    },
    { name: "session.status", module: "sessions", effect: "read", description: "Read current thread execution status without scanning conversation history." },
    { name: "session.stop", module: "sessions", effect: "agent", description: "Stop active and queued work in a task thread while preserving its history." },
    { name: "settings.read", module: "settings", effect: "read", description: "Read application preferences without environment secrets." },
    {
        name: "settings.update",
        module: "settings",
        effect: "security",
        description: "Update selected personal preferences. Global instructions apply to future task families; permission mode affects future writable turns.",
    },
    { name: "task.close", module: "tasks", effect: "agent", description: "Close a task using its normal lifecycle, including linked-PR cleanup." },
    {
        name: "task.create",
        module: "tasks",
        effect: "agent",
        description: "Create a visible task and its primary thread. Does not start work; use session.send next. Retry with the same clientRequestId.",
    },
    {
        name: "task.delete",
        module: "tasks",
        effect: "agent",
        description: "Delete a task through its normal cleanup lifecycle. Preserves checkout files and branches.",
    },
    {
        name: "task.list",
        module: "tasks",
        effect: "read",
        description: "List a bounded page of task metadata. Use query for title matching and follow nextCursor to continue.",
    },
    {
        name: "task.read",
        module: "tasks",
        effect: "read",
        description: "Read a task's saved metadata and session identities. Read conversations through session.read_messages.",
    },
    { name: "task.reopen", module: "tasks", effect: "write", description: "Reopen a closed task without starting a turn." },
    {
        name: "task.sleep",
        module: "sessions",
        effect: "write",
        description:
            "Defer task attention until a future RFC3339 time, indefinite, or pr_ready (requires active Watch PR; wakes when ready or human attention is needed). Does not close the task or schedule work.",
    },
    { name: "task.update", module: "tasks", effect: "write", description: "Update task title, description, or priority without replacing other task state." },
    { name: "task.wake", module: "sessions", effect: "write", description: "Bring a sleeping task back to attention without starting agent work." },
    { name: "terminal.list", module: "runtime", effect: "read", description: "List project terminals." },
    { name: "terminal.read", module: "runtime", effect: "read", description: "Read bounded terminal output." },
    { name: "terminal.start", module: "runtime", effect: "exec", description: "Start a terminal on the selected computer." },
    { name: "terminal.stop", module: "runtime", effect: "exec", description: "Stop a terminal." },
    { name: "terminal.write", module: "runtime", effect: "exec", description: "Send text or control bytes to a terminal." },
] as const
